import {Flex, Link} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import packageJson from '../../../package.json';
import {FOOTER_LINK_ENABLED, FOOTER_LINK_URL, FOOTER_LINK2_ENABLED, FOOTER_LINK2_URL} from "@utils/env";


const Index = () => {
    const {t} = useTranslation();
    return (
        <Flex
            as={"footer"}
            justifyContent={"space-between"}
            alignItems={"center"}
            flexWrap={"wrap"}
            gap={"8px"}
        >
            <span>{`v${packageJson.version}`}</span>
            {FOOTER_LINK_ENABLED && FOOTER_LINK_URL && (
                <Link href={FOOTER_LINK_URL} isExternal textDecoration={"underline"}>
                    {t("footer.link.label")}
                </Link>
            )}
            {FOOTER_LINK2_ENABLED && FOOTER_LINK2_URL && (
                <Link href={FOOTER_LINK2_URL} isExternal textDecoration={"underline"}>
                    {t("footer.link2.label")}
                </Link>
            )}
        </Flex>
    );
};

export default Index;
